var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 618,
    width: 1000,
    viewBox: "0 0 1000 618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "m308,0a309,309 0 1,0 2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "m690,0a309,309 0 1,0 2,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "m500,66a309,309 0 0,0 0,486 309,309 0 0,0 0-486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardCircles);
export default __webpack_public_path__ + "static/media/mastercard-circles.27e338f166c60904fbb7c7eff143f711.svg";
export { ForwardRef as ReactComponent };